"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (sentenceText, language) {
  if (["ru", "sv"].includes(language)) {
    return determineSentenceIsPassiveListBased(sentenceText, language);
  }

  if (language === "id") {
    return determineSentenceIsPassiveIndonesian(sentenceText);
  }

  if (language === "tr") {
    return determineSentenceIsPassiveTurkish(sentenceText);
  }

  if (language === "ar") {
    return determineSentenceIsPassiveArabic(sentenceText);
  }

  if (language === "he") {
    return determineSentenceIsPassiveHebrew(sentenceText);
  }

  if (language === "hu") {
    return determineSentenceIsPassiveHungarian(sentenceText);
  }
};

var _lodashEs = require("lodash-es");

var _getWords = require("../../../stringProcessing/getWords.js");

var _getWords2 = _interopRequireDefault(_getWords);

var _participlesShortenedList = require("../../russian/passiveVoice/participlesShortenedList.js");

var _participlesShortenedList2 = _interopRequireDefault(_participlesShortenedList);

var _participles = require("../../swedish/passiveVoice/participles.js");

var _participles2 = _interopRequireDefault(_participles);

var _passiveEndings = require("../../turkish/passiveVoice/passiveEndings");

var _passiveEndings2 = _interopRequireDefault(_passiveEndings);

var _nonPassivesTurkish = require("../../turkish/passiveVoice/nonPassivesTurkish");

var _nonPassiveVerbsStartingDi = require("../../indonesian/passiveVoice/nonPassiveVerbsStartingDi");

var _nonPassiveVerbsStartingDi2 = _interopRequireDefault(_nonPassiveVerbsStartingDi);

var _passiveVerbsWithLongVowel = require("../../arabic/passiveVoice/passiveVerbsWithLongVowel");

var _passiveVerbsWithLongVowel2 = _interopRequireDefault(_passiveVerbsWithLongVowel);

var _regularRootsNifal = require("../../hebrew/passiveVoice/regularRootsNifal");

var _regularRootsNifal2 = _interopRequireDefault(_regularRootsNifal);

var _regularRootsPual = require("../../hebrew/passiveVoice/regularRootsPual");

var _regularRootsPual2 = _interopRequireDefault(_regularRootsPual);

var _regularRootsHufal = require("../../hebrew/passiveVoice/regularRootsHufal");

var _regularRootsHufal2 = _interopRequireDefault(_regularRootsHufal);

var _odikVerbs = require("../../hungarian/passiveVoice/odikVerbs");

var _odikVerbs2 = _interopRequireDefault(_odikVerbs);

var _morphologicalPassiveAffixes = require("../../hungarian/passiveVoice/morphologicalPassiveAffixes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getPassiveVerbsRussian = (0, _participlesShortenedList2.default)().all; // Verb-form lists per language

var getPassiveVerbsSwedish = (0, _participles2.default)().all;
var passiveEndingsTurkish = (0, _passiveEndings2.default)();
var passivePrefixIndonesian = "di";
var nonPassivesIndonesian = (0, _nonPassiveVerbsStartingDi2.default)();
var getPassiveVerbsArabic = (0, _passiveVerbsWithLongVowel2.default)();
var nifalVerbsHebrew = (0, _regularRootsNifal2.default)();
var pualVerbsHebrew = (0, _regularRootsPual2.default)();
var hufalVerbsHebrew = (0, _regularRootsHufal2.default)();
/**
 * Matches the sentence against passive verbs.
 *
 * @param {string} sentence       The sentence to match against.
 * @param {Array}  passiveVerbs   The array containing passive verb-forms.
 *
 * @returns {Array}               The found passive verbs.
 */

var matchPassiveVerbs = function matchPassiveVerbs(sentence, passiveVerbs) {
  return (0, _lodashEs.filter)((0, _getWords2.default)(sentence), function (word) {
    return passiveVerbs.includes(word.toLocaleLowerCase());
  });
};
/**
 * Checks the passed sentence to see if it contains passive verb-forms.
 *
 * @param {string} sentence   The sentence to match against.
 * @param {string} language   The language of the text.
 *
 * @returns {Boolean}         Whether the sentence contains passive voice.
 */


var determineSentenceIsPassiveListBased = function determineSentenceIsPassiveListBased(sentence, language) {
  var passiveVerbs = [];

  switch (language) {
    case "ru":
      passiveVerbs = getPassiveVerbsRussian;
      break;

    case "sv":
      passiveVerbs = getPassiveVerbsSwedish;
      break;
  }

  return matchPassiveVerbs(sentence, passiveVerbs).length !== 0;
};
/**
 * Checks the passed sentence to see if it contains Indonesian passive verb-forms.
 *
 * @param {string} sentence   The sentence to match against.
 *
 * @returns {Boolean}         Whether the sentence contains Indonesian passive voice.
 */


var determineSentenceIsPassiveIndonesian = function determineSentenceIsPassiveIndonesian(sentence) {
  var words = (0, _getWords2.default)(sentence);
  var matchedPassives = words.filter(function (word) {
    return word.length > 4;
  });
  matchedPassives = matchedPassives.filter(function (word) {
    return word.startsWith(passivePrefixIndonesian);
  });

  if (matchedPassives.length === 0) {
    return false;
  } // Check exception list.


  var _iterator = _createForOfIteratorHelper(nonPassivesIndonesian),
      _step;

  try {
    var _loop = function _loop() {
      var nonPassive = _step.value;
      matchedPassives = matchedPassives.filter(function (word) {
        return !word.startsWith(nonPassive);
      });
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    } // Check direct precedence exceptions.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  matchedPassives = matchedPassives.filter(function (matchedPassive) {
    var matchedPassivesShouldStay = true;
    var passiveIndex = words.indexOf(matchedPassive);
    var wordPrecedingPassive = words[passiveIndex - 1];

    if (wordPrecedingPassive === "untuk") {
      matchedPassivesShouldStay = false;
    }

    return matchedPassivesShouldStay;
  });
  return matchedPassives.length !== 0;
};
/**
 * Filters out words that are passive exceptions from an array.
 *
 * @param {string[]} nonPassivesTurkish      The list of exceptions to check
 * @param {string[]} passiveEndings          The list of passive verb endings
 * @param {string[]} matchedPassives         The words from the sentence that could be passives
 * @returns {string[]}               		 The array of words with the non-passives filtered out
 *
 */


var checkTurkishNonPassivesStemsList = function checkTurkishNonPassivesStemsList(nonPassivesTurkish, passiveEndings, matchedPassives) {
  return matchedPassives.filter(function (passive) {
    return nonPassivesTurkish.some(function (stem) {
      return passiveEndings.some(function (ending) {
        var pattern = new RegExp("^" + stem + ending + "$");
        return !pattern.test(passive);
      });
    });
  });
};
/**
 * Checks the passed sentence to see if it contains Turkish passive verb forms and is not found in the non-passive full forms exception list.
 *
 * @param {string} sentence   The sentence to match against.
 *
 * @returns {Boolean}         Whether the sentence contains a Turkish verb passive voice.
 */


var determineSentenceIsPassiveTurkish = function determineSentenceIsPassiveTurkish(sentence) {
  var words = (0, _getWords2.default)(sentence);
  var matchedPassives = words.filter(function (word) {
    return word.length > 5;
  });
  matchedPassives = matchedPassives.filter(function (word) {
    return !_nonPassivesTurkish.nonPassivesFullForms.includes(word);
  });
  matchedPassives = checkTurkishNonPassivesStemsList(_nonPassivesTurkish.nonPassiveStems, passiveEndingsTurkish, matchedPassives);
  return matchedPassives.some(function (word) {
    return passiveEndingsTurkish.some(function (ending) {
      return word.endsWith(ending);
    });
  });
};
/**
 * Checks the passed sentence to see if it contains Arabic passive verb-forms.
 *
 * @param {string} sentence     The sentence to match against.
 *
 * @returns {Boolean}           Whether the sentence contains Arabic passive voice.
 */


var determineSentenceIsPassiveArabic = function determineSentenceIsPassiveArabic(sentence) {
  var arabicPrepositionalPrefix = "و";
  var words = (0, _getWords2.default)(sentence);
  var passiveVerbs = [];

  var _iterator2 = _createForOfIteratorHelper(words),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var word = _step2.value;

      // Check if the word starts with prefix و
      if (word.startsWith(arabicPrepositionalPrefix)) {
        word = word.slice(1);
      }

      var wordWithDamma = -1; // Check if the first character has a damma or if the word is in the list of Arabic passive verbs

      if (word.length >= 2) {
        wordWithDamma = word[1].search("\u064F");
      }

      if (wordWithDamma !== -1 || getPassiveVerbsArabic.includes(word)) {
        passiveVerbs.push(word);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return passiveVerbs.length !== 0;
};
/**
 * Checks if the input word's root is in the Hebrew verb roots list.
 *
 * @param {string} word             The word to check.
 * @param {string[]} verbRootsList  The Hebrew verb roots list.
 * @param {Object[]} affixesList    The list of prefixes and suffixes.
 *
 * @returns {Boolean}           Returns true if the root of the input word is in the list.
 */


var checkHebrewVerbRootsList = function checkHebrewVerbRootsList(word, verbRootsList, affixesList) {
  return verbRootsList.some(function (root) {
    return affixesList.some(function (affixes) {
      var pattern = new RegExp("^" + affixes.prefix + root + affixes.suffix + "$");
      return pattern.test(word);
    });
  });
};
/**
 * Checks the passed sentence to see if it contains Hebrew passive verb-forms.
 *
 * @param {string} sentence    The sentence to match against.
 *
 * @returns {Boolean}          Whether the sentence contains Hebrew passive voice.
 */


var determineSentenceIsPassiveHebrew = function determineSentenceIsPassiveHebrew(sentence) {
  var words = (0, _getWords2.default)(sentence);

  var _iterator3 = _createForOfIteratorHelper(words),
      _step3;

  try {
    var _loop2 = function _loop2() {
      var word = _step3.value;
      // The list of prefixes and suffixes for nif'al.
      var nifalAffixes = [{
        prefix: "(נ|אי|תי|הי|יי|ני|להי)",
        suffix: ""
      }, {
        prefix: "(תי|הי)",
        suffix: "(י|ו|נה)"
      }, {
        prefix: "נ",
        suffix: "(ים|ת|ות|תי|ה|נו|תם|תן|ו)"
      }, {
        prefix: "יי",
        suffix: "ו"
      }]; // Check if the root is in nif'al.

      var nifalPassive = checkHebrewVerbRootsList(word, nifalVerbsHebrew, nifalAffixes);

      if (nifalPassive) {
        return {
          v: true
        };
      } // The list of prefixes and suffixes for pu'al.


      var pualAffixes = [{
        prefix: "(מ|א|ת|י|נ)",
        suffix: ""
      }, {
        prefix: "תי",
        suffix: "נה"
      }, {
        prefix: "מ",
        suffix: "(ת|ים|ות)"
      }, {
        prefix: "ת",
        suffix: "(י|ו|נה)"
      }, {
        prefix: "י",
        suffix: "ו"
      }, {
        prefix: "",
        suffix: "(תי|ת|ה|נו|תם|תן|ו)"
      }, {
        prefix: "",
        suffix: ""
      }];
      var pualInfix = "ו"; // Check if the root is in pu'al.

      var pualPassive = pualVerbsHebrew.some(function (root) {
        return pualAffixes.some(function (affixes) {
          var pualPattern = new RegExp("^" + affixes.prefix + root[0] + pualInfix + root[1] + root[2] + affixes.suffix + "$");
          return pualPattern.test(word);
        });
      });

      if (pualPassive) {
        return {
          v: true
        };
      } // The list of prefixes and suffixes for huf'al.


      var hufalAffixes = [{
        prefix: "(מו|הו|או|תו|יו|נו)",
        suffix: ""
      }, {
        prefix: "מו",
        suffix: "(ת|ים|ות)"
      }, {
        prefix: "הו",
        suffix: "(תי|ת|ית|ה|נו|תם|תן|ו)"
      }, {
        prefix: "תו",
        suffix: "(ו|נה|י)"
      }, {
        prefix: "יו",
        suffix: "ו"
      }]; // Check if the root is in huf'al.

      var hufalPassive = checkHebrewVerbRootsList(word, hufalVerbsHebrew, hufalAffixes);

      if (hufalPassive) {
        return {
          v: true
        };
      }
    };

    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ret = _loop2();

      if (typeof _ret === "object") return _ret.v;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return false;
};
/**
 * Checks if the input word's root is in the Hungarian verb roots list.
 *
 * @param {string} word             The word to check.
 * @param {string[]} verbRootsList  The Hungarian verb roots list.
 * @param {string[]} prefixes       The list of prefixes.
 * @param {string[]} suffixes       The list of suffixes.
 *
 * @returns {Boolean}               Returns true if the root of the input word is in the list.
 */


var checkHungarianPassive = function checkHungarianPassive(word, verbRootsList, prefixes, suffixes) {
  return verbRootsList.some(function (root) {
    return suffixes.some(function (suffix) {
      var rootAndSuffix = root + suffix; // Check whether the word ends in a root + suffix combination.

      if (word.endsWith(rootAndSuffix)) {
        var beforeRoot = word.slice(0, word.indexOf(rootAndSuffix)); // Word is passive if nothing precedes the root or the root is preceded by a valid prefix.

        return beforeRoot === "" || prefixes.includes(beforeRoot);
      }
    });
  });
};
/**
 * Checks the passed sentence to see if it contains Hungarian passive verb-forms.
 *
 * @param {string} sentence     The sentence to match against.
 *
 * @returns {Boolean}           Whether the sentence contains Hungarian passive voice.
 */


var determineSentenceIsPassiveHungarian = function determineSentenceIsPassiveHungarian(sentence) {
  var words = (0, _getWords2.default)(sentence);
  var passiveVerbs1 = _odikVerbs2.default.odikVerbStems1;
  var passiveVerbs2 = _odikVerbs2.default.odikVerbStems2;

  var _iterator4 = _createForOfIteratorHelper(words),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var word = _step4.value;
      var checkPassiveVerb1 = checkHungarianPassive(word, passiveVerbs1, _morphologicalPassiveAffixes.verbPrefixes, _morphologicalPassiveAffixes.odikSuffixes1);

      if (checkPassiveVerb1) {
        return true;
      }

      var checkPassiveVerbs2 = checkHungarianPassive(word, passiveVerbs2, _morphologicalPassiveAffixes.verbPrefixes, _morphologicalPassiveAffixes.odikSuffixes2);

      if (checkPassiveVerbs2) {
        return true;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return false;
};
/**
 * Determines whether a sentence is passive.
 *
 * @param {string} sentenceText     The sentence to determine voice for.
 * @param {string} language         The language of the sentence part.
 *
 * @returns {boolean}               Returns true if passive, otherwise returns false.
 */